import dashboardRequest, { viewRequest } from '@/pages/dashboard/utils/dashboardRequest';
import modelRequest from '../utils/modelRequest';

// overview daily排行榜
export const getRegionCountriesZone: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_daily/countries_region_zone',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// overview daily排行榜
export const getRegionCountriesZoneXh: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_daily/xh/countries_region_zone',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// overview daily排行榜
export const getRegionCountriesZoneAcc: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_daily/acc/countries_region_zone',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// overview daily 关键指标
export const getDailyKeyPerformanceMetrics: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_daily/key_performance_metrics',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// overview daily 关键指标  去小号
export const getDailyKeyPerformanceMetricXh: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_daily/xh/key_performance_metrics',
    method: 'post',
    data,
    ignoreRequestId: false
  };
  return dashboardRequest(options);
};

// overview daily 关键指标 汇总版 去小号
export const getDailyKeyPerformanceMetricAcc: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_daily/acc/key_performance_metrics',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// overview weekly 关键指标
export const getWeeklyKeyPerformanceMetrics: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_week/key_performance_metrics',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};
// overview monthly 关键指标
export const getMonthlyKeyPerformanceMetrics: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_month/key_performance_metrics',
    method: 'post',
    data,
    ignoreRequestId: false
  };
  return dashboardRequest(options);
};

export const getMonthlyKeyPerformanceMetricsXh: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_month/xh/key_performance_metrics',
    method: 'post',
    data,
    ignoreRequestId: false
  };
  return dashboardRequest(options);
};

// overview daily/weekly/monthly 关键指标趋势图
export const getKeyPerformanceMetricsTrend: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview/rate_trend',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

export const getWeekRegionCountriesZone: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_week/countries_region_zone',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

export const getMonthRegionCountriesZone: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_month/countries_region_zone',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

export const getMonthRegionCountriesZoneXh: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_month/xh/countries_region_zone',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// overview  DAU Breakdown, Channels of New Users
export const getMetricsUsers: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_daily/metrics_users',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// overview  DAU Breakdown, Channels of New Users 去小号
export const getMetricsUsersXh: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_daily/xh/metrics_users',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// overview  DAU Breakdown, Channels of New Users 去小号
export const getMetricsUsersAcc: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_daily/acc/metrics_users',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// overview  DAU Breakdown, Channels of New Users
export const getWeekMetricsUsers: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_week/metrics_users',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// overview  DAU Breakdown, Channels of New Users
export const getMonthMetricsUsers: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_month/metrics_users',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

export const getMonthMetricsUsersXh: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_month/xh/metrics_users',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// overview Performance 宽表下载
export const downLoadDayPerformanceTable: (data: any, language: string) => Promise<any> = (data, language) => {
  const options = {
    url: `/api/v1/dashboard/overview_daily/performance/download?language=${language}`,
    method: 'post',
    data,
    rawData: true,
    responseType: 'arraybuffer',
    ignoreRequestId: false
  };
  return dashboardRequest(options);
};

// overview Performance 宽表下载 去小号
export const downLoadDayPerformanceTableXh: (data: any, language: string) => Promise<any> = (data, language) => {
  const options = {
    url: `/api/v1/dashboard/overview_daily/xh/performance/download?language=${language}`,
    method: 'post',
    data,
    rawData: true,
    responseType: 'arraybuffer',
    ignoreRequestId: false
  };
  return dashboardRequest(options);
};

// overview Performance 宽表下载 去小号
export const downLoadDayPerformanceTableAcc: (data: any, language: string) => Promise<any> = (data, language) => {
  const options = {
    url: `/api/v1/dashboard/overview_daily/acc/performance/download?language=${language}`,
    method: 'post',
    data,
    rawData: true,
    responseType: 'arraybuffer',
    ignoreRequestId: false
  };
  return dashboardRequest(options);
};



// overview Performance 宽表下载
export const downLoadMonthlyPerformanceTable: (data: any, language: string) => Promise<any> = (data, language) => {
  const options = {
    url: `/api/v1/dashboard/overview_month/performance/download?language=${language}`,
    method: 'post',
    data,
    rawData: true,
    responseType: 'arraybuffer',
    ignoreRequestId: false
  };
  return dashboardRequest(options);
};

export const downLoadMonthlyPerformanceTableXh: (data: any, language: string) => Promise<any> = (data, language) => {
  const options = {
    url: `/api/v1/dashboard/overview_month/xh/performance/download?language=${language}`,
    method: 'post',
    data,
    rawData: true,
    responseType: 'arraybuffer',
    ignoreRequestId: false
  };
  return dashboardRequest(options);
};

// overview Performance 宽表下载
export const downLoadWeeklyPerformanceTable: (data: any, language: string) => Promise<any> = (data, language) => {
  const options = {
    url: `/api/v1/dashboard/overview_week/performance/download?language=${language}`,
    method: 'post',
    data,
    rawData: true,
    responseType: 'arraybuffer',
    ignoreRequestId: false
  };
  return dashboardRequest(options);
};

//  获取overview Performance 宽表数据
export const getDayPerformanceTable: (data: any, language: string) => Promise<any> = (data, language) => {
  const options = {
    url: `/api/v1/dashboard/overview_daily/overall_performance?language=${language}`,
    method: 'post',
    data,
    ignoreRequestId: false
  };
  return dashboardRequest(options);
};

//  获取overview Performance 宽表数据 去小号
export const getDayPerformanceTableXh: (data: any, language: string) => Promise<any> = (data, language) => {
  const options = {
    url: `/api/v1/dashboard/overview_daily/xh/overall_performance?language=${language}`,
    method: 'post',
    data,
    ignoreRequestId: false
  };
  return dashboardRequest(options);
};

//  获取overview Performance 宽表数据 去小号
export const getDayPerformanceTableAcc: (data: any, language: string) => Promise<any> = (data, language) => {
  const options = {
    url: `/api/v1/dashboard/overview_daily/acc/overall_performance?language=${language}`,
    method: 'post',
    data,

    ignoreRequestId: false
  };
  return dashboardRequest(options);
};

//  获取overview Performance 宽表数据
export const getMonthlyPerformanceTable: (data: any, language: string) => Promise<any> = (data, language) => {
  const options = {
    url: `/api/v1/dashboard/overview_month/overall_performance?language=${language}`,
    method: 'post',
    data,
    ignoreRequestId: false
  };
  return dashboardRequest(options);
};

export const getMonthlyPerformanceTableXh: (data: any, language: string) => Promise<any> = (data, language) => {
  const options = {
    url: `/api/v1/dashboard/overview_month/xh/overall_performance?language=${language}`,
    method: 'post',
    data,
    ignoreRequestId: false
  };
  return dashboardRequest(options);
};

//  获取overview Performance 宽表数据
export const getWeeklyPerformanceTable: (data: any, language: string) => Promise<any> = (data, language) => {
  const options = {
    url: `/api/v1/dashboard/overview_week/overall_performance?language=${language}`,
    method: 'post',
    data,
    ignoreRequestId: false
  };
  return dashboardRequest(options);
};

//   metrics 模块 分维度
export const dimensionMetricsTrend: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_daily/dimension/metrics_trend',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

//   metrics 模块 分维度 去小号
export const dimensionMetricsTrendXh: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_daily/xh/dimension/metrics_trend',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

//   metrics 模块 分维度 去小号
export const dimensionMetricsTrendAcc: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_daily/acc/dimension/metrics_trend',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

//   metrics 模块 分维度
export const dimensionMonthlyMetricsTrend: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_month/dimension/metrics_trend',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

export const dimensionMonthlyMetricsTrendXh: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_month/xh/dimension/metrics_trend',
    method: 'post',
    data,

  };
  return dashboardRequest(options);
};

//   metrics 模块 分维度
export const dimensionWeeklyMetricsTrend: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_week/dimension/metrics_trend',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

//  metrics 模块
export const loadMetricsTrend: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_daily/metrics_trend',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

//  metrics 模块 去小号
export const loadMetricsTrendXh: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_daily/xh/metrics_trend',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

//  metrics 模块 去小号
export const loadMetricsTrendAcc: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_daily/acc/metrics_trend',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

//  metrics 模块
export const loadMonthlyMetricsTrend: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_month/metrics_trend',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

export const loadMonthlyMetricsTrendXh: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_month/xh/metrics_trend',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

//  metrics 模块
export const loadWeeklyMetricsTrend: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_week/metrics_trend',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// PC Console 模块
//  获取overview PC Console daily Performance 宽表数据
export const getPcConsoleDayPerformanceTable: (data: any, language: string) => Promise<any> = (data, language) => {
  const options = {
    // ?language=${language}
    url: `/api/v1/dashboard/pc/overview_daily/overall_performance?language=${language}`,
    method: 'post',
    data,
    ignoreRequestId: false
  };
  return dashboardRequest(options);
};

// overview DAU Breakdown, Channels of New Users
export const getPcMetricsUsers: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/pc/overview_daily/metrics_users',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// overview daily排行榜
export const getPcRegionCountriesZone: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/pc/overview_daily/countries_region_zone',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// overview daily 关键指标
export const getPcDailyKeyPerformanceMetrics: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/pc/overview_daily/key_performance_metrics',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// PC&Console Daily Breakdown
export const getPcDailyCountryRegionPlatform: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/pc/overview_daily/country_region_platform',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

//  metrics 模块
export const loadPcMetricsTrend: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/pc/overview_daily/metrics_trend',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// overview Performance 宽表下载
export const downLoadPcConsoleDayPerformanceTable: (data: any, language: string) => Promise<any> = (data, language) => {
  const options = {
    url: `/api/v1/dashboard/pc/overview_daily/overall_performance/download?language=${language}`,
    method: 'post',
    data,
    rawData: true,
    responseType: 'arraybuffer',
    ignoreRequestId: false
  };
  return dashboardRequest(options);
};


//   metrics 模块 分维度
export const dimensionPcConsoleMetricsTrend: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/pc/overview_daily/dimension/metrics_trend',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

//   分版本宽表
export const getVersionPerformanceTable: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/overview_daily/dimension/version',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};


// overview daily排行榜
export const getNightingaleRegionCountriesZone: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/pc/overview_daily/breakdown',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// overview DAU Breakdown, Channels of New Users
export const getPcV2MetricsUsers:  (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/pc/overview_daily_v2/metrics_users',
    method: 'post',
    data
  };
  return modelRequest(options);
};

// PC&Console Daily Breakdown
export const getPcV2DailyCountryRegionPlatform: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/pc/overview_daily_v2/country_region_platform',
    method: 'post',
    data,
  };
  return viewRequest(options);
};

// PC Console 模块
//  获取overview PC Console daily Performance 宽表数据
export const getPcConsoleV2DayPerformanceTable: (data: any, language: string) => Promise<any> = (data, language) => {
  const options = {
    // ?language=${language}
    url: `/api/v1/dashboard/pc/overview_daily_v2/overall_performance?language=${language}`,
    method: 'post',
    data,
    ignoreRequestId: false
  };
  return viewRequest(options);
};

// overview Performance 宽表下载
export const downLoadPcConsoleV2DayPerformanceTable: (data: any, language: string) => Promise<any> = (data, language) => {
  const options = {
    url: `/api/v1/dashboard/pc/overview_daily_v2/overall_performance/download?language=${language}`,
    method: 'post',
    data,
    rawData: true,
    responseType: 'arraybuffer',
    ignoreRequestId: false
  };
  return viewRequest(options);
};


// overview daily 关键指标
export const getPcDailyV2KeyPerformanceMetrics: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/pc/overview_daily_v2/key_performance_metrics',
    method: 'post',
    data,
  };
  return viewRequest(options);
};



//  metrics 模块
export const loadPcV2MetricsTrend: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/pc/overview_daily_v2/metrics_trend',
    method: 'post',
    data,
  };
  return viewRequest(options);
};


// PC&Console Daily Breakdown
export const getPcDailyV2CountryRegionPlatform: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/pc/overview_daily_v2/country_region_platform',
    method: 'post',
    data,
  };
  return viewRequest(options);
};



//   metrics 模块 分维度
export const dimensionPcConsoleV2MetricsTrend: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/pc/overview_daily_v2/dimension/metrics_trend',
    method: 'post',
    data,
  };
  return viewRequest(options);
};

// PC&Console Daily Breakdown
export const getPcV3DailyCountryRegionPlatform: (api:string,data: any) => Promise<any> = (api,data) => {
  const options = {
    url: api,
    method: 'post',
    data,
  };
  return viewRequest(options);
};

// PC Console 模块
//  获取overview PC Console daily Performance 宽表数据
export const getPcConsoleV3DayPerformanceTable: (api:string,data: any) => Promise<any> = (api,data) => {
  const options = {
    url: api,
    method: 'post',
    data,
    ignoreRequestId: false
  };
  return viewRequest(options);
};


// overview Performance 宽表下载
export const downLoadPcConsoleV3DayPerformanceTable: (api:string,data: any) => Promise<any> = (api,data) => {
  const options = {
    url: api,
    method: 'post',
    data,
    rawData: true,
    responseType: 'arraybuffer',
    ignoreRequestId: false
  };
  return viewRequest(options);
};

